import React from "react";
import teacherImg from "../Assests/cropped_circle_image (1).png";
import studentImg from "../Assests/cropped_circle_image.png";

const Hero = () => {
  return (
    <div className="hero-wrapper relative overflow-hidden bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 pt-10 pb-28">
      <div className="hero-inner max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* LEFT TEXT */}
        <div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-snug">
            Maharashtra's{" "}
            <span className="text-blue-600">Trusted & Affordable</span>{" "}
            <br />
            Educational Platform
          </h1>

          <p className="mt-4 text-gray-600 text-lg max-w-lg">
            Unlock your potential with the most affordable learning solution.
            Start learning with India's top educators today!
          </p>

          <button className="mt-6 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-xl text-lg font-semibold shadow-lg hover:scale-105 transition">
            Get Started
          </button>
        </div>

        {/* RIGHT SIDE IMAGES */}
        <div className="hero-images relative w-full flex justify-center items-center gap-10 mt-10">
          {/* LEFT CIRCLE */}
          <div className="img-box relative w-52 h-52 flex justify-center items-center mr-20 mt-20">
            <div className="absolute inset-0 rounded-full border-2 border-dashed border-purple-300" />
            <div className="absolute w-40 h-40 rounded-full bg-purple-100" />
            <span className="absolute -top-1 right-4 w-2.5 h-2.5 bg-blue-500 rounded-full" />
            <span className="absolute bottom-1 left-3 w-2.5 h-2.5 bg-orange-500 rounded-full" />
            <img
              src={teacherImg}
              className="w-40 sm:w-42 z-10"
              alt="teacher"
            />
                      <div className="chat-bubble absolute right-[-150px] top-16
                max-sm:relative max-sm:right-auto max-sm:top-auto
                max-sm:mt-3 max-sm:mx-auto
                max-sm:w-40               /* <-- makes it wrap */
                bg-purple-800 text-white px-3 py-2 text-xs
                rounded-xl shadow-md w-48 z-10">
                          Yeole Classes is where students learn with love and can grow with guidance
                      </div>
          </div>

          {/* RIGHT CIRCLE */}
          <div className="img-box relative w-52 h-52 flex justify-center items-center mb-20">
            <div className="absolute inset-0 rounded-full border-2 border-dashed border-purple-300" />
            <div className="absolute w-40 h-40 rounded-full bg-purple-100" />
            <span className="absolute top-0 right-4 w-2.5 h-2.5 bg-pink-500 rounded-full" />
            <span className="absolute bottom-1 left-3 w-2.5 h-2.5 bg-blue-500 rounded-full" />
            <img
              src={studentImg}
              className="w-40 sm:w-42 z-10"
              alt="student"
            />
            <div className="chat-bubble absolute left-[-120px] bg-white text-gray-800 px-3 py-2 text-xs rounded-xl shadow-md z-10">
              Vijay Sir, What is Yeole Classes?
            </div>
          </div>
        </div>
      </div>

      {/* ---------  MOBILE-ONLY STYLES (scoped) --------- */}
      <style jsx>{`
        @media (max-width: 767px) {
          .hero-images {
            flex-direction: column;
            gap: 3rem;
            margin-top: 2rem;
          }
          .img-box {
            margin: 0 auto !important;
            width: 11rem;
            height: 11rem;
          }
          .img-box .w-40 {
            width: 8.5rem;
            height: 8.5rem;
          }
          .img-box img {
            width: 8.5rem;
          }
          .chat-bubble {
            position: absolute;
            white-space: nowrap;
            top: 50%;
            transform: translateY(-50%);
          }
          .img-box:first-of-type .chat-bubble {
            left: 100%;
            margin-left: 0.75rem;
          }
          .img-box:last-of-type .chat-bubble {
            right: 100%;
            margin-right: 0.75rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Hero;